import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';
import { deleteModelos, reorderModels } from '../../../actions/admin';
import SortableComponent from './SortableList'
import _ from 'lodash';

class ModelsList extends Component{
    constructor(props) {
        super(props);
        this.state = {
            modelsToDelete: [],
            selectAll: false,
            organizeMode: false,
            files: []
        };
    }
    deleteModelos(){
        this.props.deleteModelos({
            caso_id: this.props.caso_id,
            modelos:this.state.modelsToDelete
        })
    }
    organizeOn(){
        this.setState({ organizeMode: true});
    }
    organizeOff(){
        this.setState({ organizeMode: false});
    }
    reOrder(files){
        this.setState({ files });
    }
    saveOrder(){
        const reorderedModels = this.state.files.items.map((item, index) => {
           item.order = index;
           return item;
        });
        this.props.reorderModels(reorderedModels, this.props.caso_id)
        this.setState({ organizeMode: false});
    }
    handleInputAll(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        this.setState({
            [name]: value
        });
    }
    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        this.setState({
            [name]: value
        });

        if(value){
            this.setState({modelsToDelete: [ ...this.state.modelsToDelete, name ]});
        }else{
            let index = this.state.modelsToDelete.indexOf(name)
            this.setState((prevState) => ({
                modelsToDelete: [...prevState.modelsToDelete.slice(0,index), ...prevState.modelsToDelete.slice(index+1)]
            }))
        }

    }
    componentDidMount(){
        this.setState({files: this.props.models});
    }
    componentDidUpdate(prevProps, prevState){
        if(prevState.selectAll === this.state.selectAll) return
        if(this.state.selectAll){
            this.setState({modelsToDelete: this.props.models});
            this.props.models.map(item => {
                this.setState({
                    [item.id]: true,
                    modelsToDelete: this.props.models.map(item => { return item.id })
                });
            })
        }else{
            this.setState({modelsToDelete: []});
            this.props.models.map(item => {
                this.setState({
                    [item.id]: false,
                    modelsToDelete: []
                });
            })
        }
    }
    renderModelRow(){
        return _.orderBy(this.props.models, ['order'],['asc']).map((model)=>{
            return (<tr key={model.id}>
                <td>
                    <input
                        name={model.id}
                        type="checkbox"
                        checked={this.state[model.id] || false}
                        onChange={this.handleInputChange.bind(this)} />
                </td>
                <td>
                    {model.url}
                </td>
            </tr>)
        })
    }
    render(){
        if(!this.props.models || this.props.models.length === 0){
            return <span></span>
        }else{
            return(
                <div>
                    <div className="table-actions">
                        {!this.state.organizeMode ?
                            <span>
                                <Button color="warning" onClick={this.deleteModelos.bind(this)}><i
                                    className="fa fa-trash-o"/> Borrar seleccionados</Button>
                                <Button color="info" onClick={this.organizeOn.bind(this)}><i className="fa fa-recycle" /> Ordenar modelos</Button>
                            </span>
                            :
                            <span>
                                <Button color="info" onClick={this.saveOrder.bind(this)}><i className="fa fa-save"/> Guardar orden</Button>
                                <Button color="secondary" onClick={this.organizeOff.bind(this)}> Cancelar</Button>
                            </span>
                        }
                    </div>
                    {!this.state.organizeMode ?
                    <table className="table table-hover">
                        <thead>
                        <tr>
                            <th>
                                <input
                                    name="selectAll"
                                    type="checkbox"
                                    checked={this.state.selectAll}
                                    onChange={this.handleInputAll.bind(this)}/>
                            </th>
                            <th>url</th>
                        </tr>
                        </thead>
                        <tbody>
                        {this.renderModelRow()}
                        </tbody>
                    </table>
                        :
                    <SortableComponent
                        SortableItemClassName="noselect"
                        files={this.props.models}
                        onSortEnd={this.onSortEnd}
                        useDragHandle={true}
                        reorder={this.reOrder.bind(this)}
                    />
                    }
                </div>
            )
        }
    }
}
function mapStateToProps(state) {
    return {
        models: state.caso.modelosObj,
        caso_id: state.caso.id
    };
}

export default connect(mapStateToProps, {
    reorderModels,
    deleteModelos
})(ModelsList);


// WEBPACK FOOTER //
// ./resources/assets/js/components/forms/models/ModelsList.jsx